import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { setLocale, type Locale } from './index';

/** Small helper around vue-i18n for the EN/CZ switcher. */
export function useLocale() {
  const { locale } = useI18n();
  const current = computed(() => locale.value as Locale);
  function set(next: Locale) {
    setLocale(next);
  }
  function toggle() {
    set(locale.value === 'en' ? 'cs' : 'en');
  }
  return { current, set, toggle };
}
